export default "__VITE_ASSET__BNPHw2jK__"